// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';

import type { PjpMetricGraphModelType } from 'common/models/flow/PjpMetricGraph';

export type PjpInsightsDashboardModelType = {
    clientId: string,
    dashboardId: string,
    dashboardData: PjpInsightsDashboardDataModelType,
    parentDashboardId: ?string,
    label: string,
    sequence: number,
    active: boolean,
    dashboardType: PjpDashboardType
};

export type PjpDashboardType = 'PJP';

export type PjpInsightsDashboardDataModelType = {
    graphs: Array<PjpMetricGraphModelType>
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpInsightsDashboard extends ImmutableModel {
    static fromJS(json: PjpInsightsDashboardModelType): PjpInsightsDashboard {
        const state: Object = Object.assign({}, json);
        state.dashboardData = PjpInsightsDashboardData.fromJS(
            state.dashboardData
        );
        return new this(Immutable.Map(state));
    }

    toJS(): PjpInsightsDashboardModelType {
        return {
            clientId: this.clientId,
            dashboardId: this.dashboardId,
            dashboardData: this.dashboardData.toJS(),
            parentDashboardId: this.parentDashboardId,
            label: this.label,
            sequence: this.sequence,
            active: this.active,
            dashboardType: this.dashboardType
        };
    }

    get clientId(): string {
        return this._state.get('clientId');
    }

    setClientId(clientId: string): this {
        return this.clone(this._state.set('clientId', clientId));
    }

    get dashboardId(): string {
        return this._state.get('dashboardId');
    }

    setDashboardId(dashboardId: string): this {
        return this.clone(this._state.set('dashboardId', dashboardId));
    }

    get dashboardData(): PjpInsightsDashboardData {
        return this._state.get('dashboardData');
    }

    setDashboardData(dashboardData: PjpInsightsDashboardData): this {
        return this.clone(this._state.set('dashboardData', dashboardData));
    }

    get parentDashboardId(): ?string {
        return this._state.get('parentDashboardId');
    }

    setParentDashboardId(parentDashboardId: ?string): this {
        return this.clone(
            this._state.set('parentDashboardId', parentDashboardId)
        );
    }

    get label(): string {
        return this._state.get('label');
    }

    setLabel(label: string): this {
        return this.clone(this._state.set('label', label));
    }

    get sequence(): number {
        return this._state.get('sequence');
    }

    setSequence(sequence: number): this {
        return this.clone(this._state.set('sequence', sequence));
    }

    get active(): boolean {
        return this._state.get('active');
    }

    setActive(active: boolean): this {
        return this.clone(this._state.set('active', active));
    }

    get dashboardType(): PjpDashboardType {
        return this._state.get('dashboardType');
    }

    setDashboardType(dashboardType: PjpDashboardType): this {
        return this.clone(this._state.set('dashboardType', dashboardType));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpInsightsDashboardData extends ImmutableModel {
    static fromJS(
        json: PjpInsightsDashboardDataModelType
    ): PjpInsightsDashboardData {
        const state: Object = Object.assign({}, json);
        state.graphs = Immutable.List(state.graphs).map(item =>
            PjpMetricGraph.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): PjpInsightsDashboardDataModelType {
        return {
            graphs: this.graphs.toArray().map(item => item.toJS())
        };
    }

    get graphs(): Immutable.List<PjpMetricGraph> {
        return this._state.get('graphs');
    }

    setGraphs(graphs: Immutable.List<PjpMetricGraph>): this {
        return this.clone(this._state.set('graphs', graphs));
    }
}
